import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    Table,
    TablePagination,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Avatar,
    colors
} from '@material-ui/core';

import {
    ConfirmIconButton
} from '../../../../common';

import { PageContext } from '../PageContext';

import { ApplicationRoles } from '../../../../../helpers';

import TableIcon from '@material-ui/icons/TableChartOutlined';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
    },
    table: {

    },
    crudTable: {
        display: 'flex',
        alignItems: 'center'
    },
    header: {
        color: colors.blueGrey[500],
        backgroundColor: colors.grey[200]
    },
    avatar: {
        marginRight: theme.spacing(1)
    },
    overlayContainer: {
        position: "relative"
    },
    overlay: {
        position: "absolute",
        top: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        opacity: ".7"
    }
}));

export const UserTables = ({
    searchText,
    itemsPerPage,
    loading,
    disabled,
    onLoadMore,
    onToggleTable,
    ...props }) => {
    const classes = useStyles();

    const {
        state
    } = useContext(PageContext);

    const {
        user,
        roles,
        bundle,
        tables
    } = state;

    const [pageIndex, setPageIndex] = useState(-1);
    const pageIndexChangeHandler = (e, index) => {
        setPageIndex(index);
    }

    const [pageSize, setPageSize] = useState(-1);
    const pageSizeChangeHandler = (e) => {
        setPageSize(e.target.value)
    }

    const toggleTableClickHandler = (role, user, table) => {
        if (onToggleTable) onToggleTable(role, user, table);
    }

    useEffect(() => {
        if ((pageIndex !== -1 || pageSize !== -1) && onLoadMore) {
            onLoadMore(searchText, Math.max(0, pageIndex), Math.max(itemsPerPage, pageSize));
        }
    }, [pageIndex, pageSize]);

    useEffect(() => {
        if (searchText
            && searchText !== undefined
            && onLoadMore) {
            onLoadMore(searchText, 0, Math.max(itemsPerPage, pageSize));
        }
    }, [searchText]);

    const isUserAnAdmin = user && user.roles && (user.roles.find(x => x.roleName === ApplicationRoles.Administrator) !== undefined);
    const userTablesCount = (user.tables ? user.tables.length : 0);

    return (
        <Card className={clsx(classes.root, props.className)}>
            <CardHeader
                className={classes.header}
                title={
                    <Grid container alignItems="center" justifyContent="space-between">
                        <Grid item>
                            <Typography variant="h6">
                                User has <strong>{userTablesCount}</strong> {userTablesCount > 1 ? "tables" : "table"}
                            </Typography>
                        </Grid>
                    </Grid>
                }
            />
            <CardContent>
                {tables ?
                    <div className={classes.overlayContainer}>
                        <TablePagination
                            component="div"
                            count={bundle ? bundle.totalItems : 0}
                            onPageChange={pageIndexChangeHandler}
                            onRowsPerPageChange={pageSizeChangeHandler}
                            page={Math.max(0, pageIndex)}
                            rowsPerPage={Math.max(itemsPerPage, pageSize)}
                            rowsPerPageOptions={[itemsPerPage / 2, itemsPerPage, itemsPerPage * 2]}
                        />
                        <Table className={classes.table} arial-label="tables list">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ width: "70%" }}>Table Name</TableCell>
                                    {roles && roles.map(
                                        (role, index) =>
                                            <TableCell key={index} align="center">
                                                {role.roleName}
                                            </TableCell>
                                    )}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tables.map((table, index) =>
                                    <TableRow key={index}>
                                        <TableCell component="th" scope="row">
                                            <div className={classes.crudTable}>
                                                <Avatar
                                                    aria-label="avatar"
                                                    className={classes.avatar}>
                                                    <TableIcon />
                                                </Avatar>
                                                <Typography>
                                                    {table.tableName}
                                                </Typography>
                                            </div>
                                        </TableCell>
                                        {roles && roles.map(
                                            (role, index) => {
                                                const userTable = isUserAnAdmin || user.tables.find(x => x.tableId === table.managedTableId);
                                                const hasTable = isUserAnAdmin || userTable !== undefined;
                                                const hasRole = hasTable && (isUserAnAdmin || userTable.roleIds.find(x => x === role.applicationRoleId) !== undefined);
                                                return (
                                                    <TableCell key={index} align="center">
                                                        <ConfirmIconButton
                                                            icon={hasRole ? <CheckBoxIcon /> : <CheckBoxBlankIcon />}
                                                            tooltip={hasRole ? isUserAnAdmin ? "Administrator has full access" : "Revoke" : "Assign"}
                                                            confirmTooltip={hasRole ? "Confirm revoke" : "Confirm assign"}
                                                            cancelTooltip={hasRole ? "Cancel revoke" : "Cancel assign"}
                                                            disabled={disabled || isUserAnAdmin}
                                                            onClick={() => toggleTableClickHandler(role, user, table)}
                                                        />
                                                    </TableCell>
                                                );
                                            }
                                        )}
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            count={bundle ? bundle.totalItems : 0}
                            onPageChange={pageIndexChangeHandler}
                            onRowsPerPageChange={pageSizeChangeHandler}
                            page={Math.max(0, pageIndex)}
                            rowsPerPage={Math.max(itemsPerPage, pageSize)}
                            rowsPerPageOptions={[itemsPerPage / 2, itemsPerPage, itemsPerPage * 2]}
                        />
                        {loading && <div className={classes.overlay} />}
                    </div>
                    :
                    <Typography variant="caption">
                        No tables assigned for this role
                    </Typography>
                }
            </CardContent>
        </Card>
    );
}